import React, { useContext } from "react"
import { Link } from "react-router-dom"
import "../../../../styles/task.scss"
// import user from "../../../.assets/user-img.png"
import InstructorTab from "./InstructorTab"
import { SidebarContext } from "../../../auth/ProtectedRoute"

const Instructor = () => {
  const { userName, sidebarData } = useContext(SidebarContext)
  return (
    <div className="task-dashboard" style={{ padding: "40px" }}>
      <div className="action-header">
        <h1>Instructor</h1>
      </div>
      <div className="project-table" style={{ display: "flex", flexDirection: "column" }}>
        <InstructorTab />
      </div>
    </div>
  )
}

export default Instructor
